// This handles a page reload if the user has cleared cookies after initial page rendering
// else registration, login and add-to-cart will not work.
const VSF_COUNTRY_COOKIE = 'vsf-country';

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const VSF_COUNTRY = useCookie(VSF_COUNTRY_COOKIE);

  router.beforeEach((to, from, next) => {
    const hasNoCookies = !VSF_COUNTRY.value;
    const isNavigating = from.path !== to.path;
    if (hasNoCookies && isNavigating) {
      window.location.href = to.path;
    }

    next();
  });
});
